import React, { Component } from 'react';
import HistorialTarjetas from './HistorialTarjetas'
import TablaIntegrantes from './TablaIntegrantes';
import ModalContenedor from '../Modales/ModalContenedor';
 
//var mockIntegrantes = [{ Nombre: "Roberto Amigorila", Numero: "XXXX XXXX XXXX 8569", Vinculo: "Titular", Estado: "Operativa", Tipo: "Prepaga", Cliente: 18, IdAdintar: 318 }, { Nombre: "Roberto Amigorila", Numero: "XXXX XXXX XXXX 1472", Vinculo: "Titular", Estado: null, Tipo: "Prepaga", Cliente: 18, IdAdintar: 300 }, { Nombre: "Macarena Ehmacarenaaa", Numero: "XXXX XXXX XXXX 5623", Vinculo: "Adicional", Estado: "Operativa", Tipo: "Prepaga", Cliente: 19, IdAdintar: 319 }] //borrar

class IntegrantesCuenta extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.abrirPopUp = this.abrirPopUp.bind(this);
        this.obtenerHisotrialTarjetas = this.obtenerHisotrialTarjetas.bind(this);
    }
    
    obtenerHisotrialTarjetas(modalId, abrirCerrar) {
        this.props.actions.obtenerHisotrialTarjetas(1, abrirCerrar)
    }

    abrirPopUp(modalId, abrirCerrar) {
        this.props.actions.abrirPopUp(1, abrirCerrar)
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
        if(this.props.data.datosCuentaGenerales){
            this.props.actions.getScreenDataIntegrantes(this.props.cuentaId)
        }
    }

    render() {

        let textoHistorialTarj = "Ver historial de tarjetas";
        let { data, actions, permisoModificacion, permisosIntegrantes } = this.props;

        ///PERMISOS///
        const permisoModificacionIntegrantes = permisosIntegrantes.Modificacion;
        const permisoBloqueoTarjeta          = permisosIntegrantes.Modificacion;
        const permisoDenunciaTarjeta         = permisosIntegrantes.Modificacion;
        const permisoHabilitacionTarjeta     = permisosIntegrantes.Modificacion;
        const permisoBlanqueoPINTarjeta      = permisosIntegrantes.Modificacion;
        const permisoReimpresionTarjeta      = permisosIntegrantes.Modificacion;
        const permisoConfirmacionIntegrantes = permisosIntegrantes.Confirmacion;
        ///FIN PERMISOS///

        const permisos = {permisoConfirmacionIntegrantes, permisoModificacionIntegrantes, permisoBloqueoTarjeta, permisoDenunciaTarjeta, permisoHabilitacionTarjeta, permisoBlanqueoPINTarjeta, permisoReimpresionTarjeta}; 
        let integrantes=[];
        integrantes = this.props.data && this.props.data.IntegrantesCuenta.integrantes;
        
        return (
            <div className='col-md-12'>
                {data.modalHistorialTarjetas && <HistorialTarjetas abrirPopUp={this.abrirPopUp} HistorialTarjetas={data}/>}
                {data.IntegrantesCuenta.modalAbierto && <ModalContenedor data={data} actions={actions} modalTipo={data.IntegrantesCuenta.modalAbierto} />}
                <div className="row top-separator-xs">
                    <div className="col-xs-12 bottom-separator procesoColumnRight div-padding-0">
                        <h2>
                            Integrantes de la Cuenta
                        </h2>
                        <div className='icono-tarjeta-azul clickable' onClick={() => this.obtenerHisotrialTarjetas(2, true)} data-toggle="tooltip" data-title={textoHistorialTarj} data-placement="left"></div>                     
                    </div>                      
                    <div>
                        {data.tieneHistorialTarjeta == false && <label className="error" style={{ float: "right"}}>No existen tarjetas anteriores para la cuenta</label> } 
                    </div> 
                </div>  
                <div className='row'>
                    <div className='col-md-12 div-padding-0'>
                       <TablaIntegrantes permisos={permisos} permisoModificacion={permisoModificacion} novedades={data.IntegrantesCuenta.novedades || []} actions={this.props.actions} data={data} integrantes={integrantes/*mockIntegrantes*/}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default IntegrantesCuenta;